import { create } from 'zustand';
import { MY_WORK_SYNC_TABS } from '../lib/my-work/sync-constants.js';

const emptyVersions = () => Object.fromEntries(MY_WORK_SYNC_TABS.map((tab) => [tab, 0]));

/** Local mutation skip expires so a dropped socket cannot swallow a later invalidation. */
export const MY_WORK_SKIP_TTL_MS = 2000;

/**
 * Tab version bumps for My Work socket sync (Unit reference-version mirror).
 */
export const useMyWorkSyncStore = create((set, get) => ({
    versions: emptyVersions(),
    pendingSkip: new Map(),

    skipNext: (tabs = [], now = Date.now()) => {
        const next = new Map(get().pendingSkip);
        const until = now + MY_WORK_SKIP_TTL_MS;
        for (const tab of tabs) {
            if (MY_WORK_SYNC_TABS.includes(tab)) next.set(tab, until);
        }
        set({ pendingSkip: next });
    },

    consumeSkip: (tab, now = Date.now()) => {
        const pending = get().pendingSkip;
        if (!pending.has(tab)) return false;
        const until = pending.get(tab);
        const next = new Map(pending);
        next.delete(tab);
        set({ pendingSkip: next });
        return until >= now;
    },

    bumpTabs: (tabs = [], version) => {
        const keys = tabs.includes('*') ? [...MY_WORK_SYNC_TABS] : tabs;
        if (!keys.length) return;
        const nextVersion = typeof version === 'number' ? version : Date.now();
        set((state) => {
            const versions = { ...state.versions };
            for (const tab of keys) {
                if (!MY_WORK_SYNC_TABS.includes(tab)) continue;
                versions[tab] = nextVersion;
            }
            return { versions };
        });
    },

    resetForTenant: () => {
        set({ versions: emptyVersions(), pendingSkip: new Map() });
    },
}));

/**
 * @param {string[]} tabs
 */
export function skipNextMyWorkRefetch(tabs) {
    useMyWorkSyncStore.getState().skipNext(tabs);
}
